module.exports = __webpack_public_path__ + "png/header-conf-dark.png";